import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/images/Logo.png";

// Admin dashboard footer — single-language (English only, no i18n in
// dashboard/). Mirrors web/src/components/Footer.jsx visually with the
// new teal #16729A hover color and admin-flavoured links.

interface FooterLinkProps {
  to: string;
  external?: boolean;
  children: React.ReactNode;
}

const linkClass =
  "text-[14px] font-normal text-[#374151] hover:text-[#16729A] transition-colors no-underline font-sans";

const FooterLink: React.FC<FooterLinkProps> = ({ to, external, children }) => {
  if (external) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" className={linkClass}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} className={linkClass}>
      {children}
    </Link>
  );
};

const Footer: React.FC = () => (
  <footer className="px-3 py-6 font-sans">
    <div className="max-w-[1280px] mx-auto bg-[#F0F0F0] rounded-[12px] px-8 md:px-12 py-10">
      <div className="flex flex-col md:flex-row gap-8 md:gap-12">
        <div className="md:w-[320px]">
          <Link to="/" className="flex items-center no-underline" aria-label="TieUp Admin home">
            <img src={Logo} alt="TieUp" className="h-10 w-auto" />
          </Link>
          <p className="mt-4 text-[14px] text-[#666666] leading-[1.6]">
            Admin console for the TieUp marketplace — moderate users, offers, services and withdrawals.
          </p>
        </div>

        <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
          <div>
            <h3 className="text-[15px] font-bold text-[#1A1A1A] mb-4">Moderation</h3>
            <ul className="space-y-3">
              <li><FooterLink to="/customers">Customers</FooterLink></li>
              <li><FooterLink to="/offers">Offers</FooterLink></li>
              <li><FooterLink to="/services">Services</FooterLink></li>
            </ul>
          </div>

          <div>
            <h3 className="text-[15px] font-bold text-[#1A1A1A] mb-4">Operations</h3>
            <ul className="space-y-3">
              <li><FooterLink to="/orders">Orders</FooterLink></li>
              <li><FooterLink to="/withdraw">Withdrawals</FooterLink></li>
              <li><FooterLink to="/profile">Profile</FooterLink></li>
            </ul>
          </div>

          <div>
            <h3 className="text-[15px] font-bold text-[#1A1A1A] mb-4">Public Site</h3>
            <ul className="space-y-3">
              <li><FooterLink external to="https://tieupfreelance.com">tieupfreelance.com</FooterLink></li>
              <li><FooterLink external to="https://tieupfreelance.com/privacy">Privacy</FooterLink></li>
              <li><FooterLink external to="https://tieupfreelance.com/contact">Contact</FooterLink></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-[#E0E0E0] mt-10 pt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <p className="text-[14px] text-[#666666]">&copy; 2026 TieUp Admin. All rights reserved.</p>
        <div className="flex items-center gap-6">
          <FooterLink external to="https://www.facebook.com/startieup">Facebook</FooterLink>
          <FooterLink external to="https://www.instagram.com">Instagram</FooterLink>
          <FooterLink external to="https://www.youtube.com">Youtube</FooterLink>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
